// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.catalog-page {
    background: #ffffff;
    color: var(--mg-ink);
    overflow-x: clip;
    padding: 0 0 72px;
}

.catalog-shell {
    box-sizing: border-box;
    margin: 0 auto;
    max-width: none;
    padding: 0 18px;
    width: 100%;
}

.catalog-hero {
    border-bottom: 1px solid rgba(17, 17, 17, 0.1);
    padding: 20px 0 28px;
}

.catalog-hero__content {
    align-items: baseline;
    display: grid;
    gap: 20px;
    grid-template-columns: minmax(0, 1fr);
}

.catalog-hero__title {
    font-family: var(--mg-serif);
    font-size: clamp(28px, 3vw, 44px);
    font-weight: 500;
    letter-spacing: 0;
    line-height: 1.15;
    margin: 0;
    text-transform: none;
}

/* Catalog pages begin with controls; category context already lives in the header. */
.catalog-shell > .breadcrumbs__navigation_chain,
.catalog-shell > .catalog-hero,
.catalog-shell > .catalog-visual-nav {
    display: none;
}

.catalog-visual-nav {
    display: grid;
    gap: 1px;
    grid-template-columns: repeat(6, minmax(0, 1fr));
    overflow: hidden;
    padding: 20px 0 26px;
}

.catalog-visual-nav__item {
    color: inherit;
    display: grid;
    gap: 10px;
    min-width: 0;
    text-decoration: none;
}

.catalog-visual-nav__image-wrap {
    aspect-ratio: 1 / 1;
    background: #f2f2f2;
    display: block;
    overflow: hidden;
}

.catalog-visual-nav__image {
    display: block;
    height: 100%;
    object-fit: contain;
    transition: transform 0.45s cubic-bezier(.22, .61, .36, 1);
    width: 100%;
}

.catalog-visual-nav__item:hover .catalog-visual-nav__image {
    transform: scale(1.025);
}

.catalog-visual-nav__title {
    font-size: 12px;
    line-height: 1.3;
    padding: 0 8px;
}

.catalog-hero__description {
    color: #6b6b6b;
    font-size: 14px;
    line-height: 1.65;
    margin: 18px 0 0;
    max-width: 560px;
}

.catalog-hero__meta {
    color: #6b6b6b;
    display: flex;
    flex-direction: column;
    font-size: 11px;
    gap: 0;
    letter-spacing: 0.08em;
    text-align: right;
    text-transform: uppercase;
}

.catalog-toolbar {
    align-items: center;
    border-bottom: 1px solid rgba(17, 17, 17, 0.1);
    display: flex;
    gap: 16px;
    justify-content: space-between;
    min-height: 58px;
    padding: 8px 0;
}

.catalog-toolbar__left {
    align-items: center;
    display: flex;
    gap: 14px;
}

.catalog-toolbar__count,
.catalog-toolbar__note {
    color: #6b6b6b;
    font-size: 12px;
    letter-spacing: 0.14em;
    text-transform: uppercase;
}

.catalog-toolbar__count {
    display: inline;
    margin-left: auto;
    text-align: right;
}

.catalog-sort {
    align-items: center;
    display: inline-flex;
    gap: 10px;
}

.catalog-sort__label {
    color: #6b6b6b;
    font-size: 12px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.catalog-sort__select {
    background: #ffffff;
    border: 0;
    border-radius: 0;
    color: #111111;
    font-size: 13px;
    min-height: 40px;
    min-width: 180px;
    padding: 0 12px;
}

.catalog-grid {
    display: grid;
    gap: 0;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    list-style: none;
    margin: 0;
    padding: 0;
}

.catalog-card {
    min-width: 0;
    overflow: hidden;
    position: relative;
}

.catalog-card__favorite {
    opacity: 0;
    position: absolute;
    right: 14px;
    top: 14px;
    transition: opacity 0.2s ease;
    z-index: 2;
}

.catalog-card__favorite button {
    background: transparent;
    border: 0;
    border-radius: 999px;
    display: inline-flex;
}

.catalog-card__link {
    color: inherit;
    display: block;
    text-decoration: none;
}

.catalog-card__image-frame {
    background: #ffffff;
    border: 0;
    border-radius: 0;
    overflow: hidden;
    line-height: 0;
    padding: 0;
    position: relative;
    touch-action: pan-y;
    -webkit-tap-highlight-color: transparent;
}

.catalog-card__image-link {
    color: inherit;
    display: block;
}

.catalog-card:hover .catalog-card__favorite,
.catalog-card:focus-within .catalog-card__favorite {
    opacity: 1;
}

.catalog-card__image-wrap {
    aspect-ratio: 1 / 1;
    background: #ffffff;
    overflow: hidden;
    position: relative;
}

.catalog-card__image {
    backface-visibility: hidden;
    display: block;
    flex: 0 0 100%;
    height: 100%;
    object-fit: contain;
    pointer-events: none;
    -webkit-user-select: none;
            user-select: none;
    -webkit-user-drag: none;
    width: 100%;
}

.catalog-card__image-track {
    display: flex;
    height: 100%;
    transition: transform 0.3s cubic-bezier(.22, .61, .36, 1);
    width: 100%;
    will-change: transform;
}

.catalog-card__image-progress {
    display: none;
}

.catalog-card__image.is-muted {
    opacity: 0.48;
}

.catalog-card__gallery-nav {
    inset: 0;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    transition: opacity 0.18s ease;
}

.catalog-card:hover .catalog-card__gallery-nav,
.catalog-card:focus-within .catalog-card__gallery-nav {
    opacity: 1;
}

.catalog-card.is-returning .catalog-card__gallery-nav {
    opacity: 0;
}

.catalog-card__gallery-arrow {
    align-items: center;
    background: transparent;
    border: 0;
    color: #111;
    cursor: pointer;
    display: flex;
    font-family: var(--mg-sans);
    font-size: 27px;
    font-weight: 500;
    height: 38px;
    justify-content: center;
    line-height: 1;
    padding: 0 0 3px;
    pointer-events: auto;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 38px;
    transition: opacity 0.15s ease, transform 0.15s ease;
}

.catalog-card__gallery-arrow:active {
    transform: translateY(-50%) scale(0.9);
}

.catalog-card__gallery-arrow:focus-visible {
    outline: 1px solid currentColor;
    outline-offset: -7px;
}

.catalog-card__gallery-arrow--prev { left: 12px; }
.catalog-card__gallery-arrow--next { right: 12px; }

.catalog-card__badge {
    background: transparent;
    color: #111111;
    font-size: 11px;
    left: 14px;
    letter-spacing: 0.14em;
    padding: 0;
    position: absolute;
    text-transform: uppercase;
    top: 14px;
}

.catalog-card__body {
    display: grid;
    align-content: start;
    gap: 1px;
    min-height: 0;
    padding: 11px 12px 14px;
    text-align: left;
}

@media (hover: hover) and (pointer: fine) {
    .catalog-card__image-track {
        position: relative;
        transform: none !important;
    }

    .catalog-card__image {
        inset: 0;
        opacity: 0;
        position: absolute;
        transition: opacity 0.32s cubic-bezier(.22, .61, .36, 1);
        will-change: opacity;
    }

    .catalog-card__image.is-active {
        opacity: 1;
        z-index: 1;
    }

    .catalog-card__image.is-muted {
        opacity: 0;
    }

    .catalog-card__image.is-active.is-muted {
        opacity: 0.48;
    }

    .catalog-card.is-hover-preview .catalog-card__image {
        transition-duration: 0.52s;
        transition-timing-function: cubic-bezier(.22, .61, .36, 1);
    }

    .catalog-card.is-returning .catalog-card__image {
        transition-duration: 0.72s;
        transition-timing-function: cubic-bezier(.33, 1, .68, 1);
    }
}

.catalog-card__brand {
    font-size: 12px;
    font-weight: 700;
    letter-spacing: -0.01em;
    line-height: 1.35;
    text-transform: uppercase;
    white-space: nowrap;
}

.catalog-card__title {
    color: #292929;
    font-family: var(--mg-sans);
    display: block;
    font-size: 12px;
    font-weight: 500;
    line-height: 1.45;
    min-height: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.catalog-card__details {
    color: #6b6b6b;
    font-size: 12px;
    line-height: 1.5;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.catalog-card__price {
    color: #111111;
    font-size: 12px;
    font-variant-numeric: tabular-nums;
    font-weight: 700;
    padding-top: 0;
}

.catalog-card__price-row {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: 8px 12px;
    justify-content: flex-start;
    margin-top: 9px;
}

.catalog-card__price--old {
    color: #8e8a84;
    font-weight: 500;
    text-decoration: line-through;
}

.catalog-load-more {
    margin: 40px auto 0;
    max-width: 520px;
    text-align: center;
}

.catalog-load-more__count {
    color: #171717;
    font-size: 13px;
    letter-spacing: 0.04em;
    margin-bottom: 24px;
}

.catalog-load-more__button {
    align-items: center;
    border: 1px solid #171717;
    color: #171717;
    cursor: pointer;
    display: flex;
    font-size: 14px;
    font-weight: 500;
    justify-content: center;
    letter-spacing: 0.08em;
    min-height: 64px;
    padding: 0 24px;
    text-decoration: none;
    text-transform: uppercase;
    transition: background-color 0.2s ease, color 0.2s ease;
    width: 100%;
}

.catalog-load-more__button:hover:not(:disabled) {
    background: #171717;
    color: #ffffff;
}

.catalog-load-more__button:disabled {
    cursor: wait;
    opacity: 0.55;
}

@media (max-width: 1100px) {
    .catalog-grid {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }
}

@media (min-width: 1600px) {
    .catalog-grid {
        grid-template-columns: repeat(5, minmax(0, 1fr));
    }
}

@media (min-width: 2100px) {
    .catalog-grid {
        grid-template-columns: repeat(6, minmax(0, 1fr));
    }
}

@media (max-width: 820px) {
    .catalog-shell { padding: 0 12px; }

    .catalog-toolbar {
        align-items: center;
        flex-direction: row;
    }

    .catalog-toolbar__left { flex-wrap: nowrap; }

    .catalog-visual-nav {
        display: flex;
        margin-right: -12px;
        overflow-x: auto;
        scrollbar-width: none;
    }

    .catalog-visual-nav::-webkit-scrollbar { display: none; }

    .catalog-visual-nav__item { flex: 0 0 132px; }

}

@media (max-width: 540px) {
    .catalog-page {
        padding-top: 0;
    }

    .catalog-hero__title {
        font-size: 30px;
    }

    .catalog-grid {
        gap: 0;
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .catalog-toolbar,
    .catalog-toolbar__left {
        width: 100%;
    }

    .catalog-toolbar__left { width: auto; }

    .catalog-sort {
        display: grid;
        grid-template-columns: auto minmax(0, 1fr);
        justify-content: space-between;
        width: 100%;
    }

    .catalog-sort__select {
        justify-self: end;
        max-width: 190px;
        min-width: 0;
        width: 100%;
    }

    .catalog-card__image-frame {
        padding: 0;
    }

    .catalog-card__title {
        font-size: 12px;
    }

    .catalog-card__brand,
    .catalog-card__details,
    .catalog-card__price {
        font-size: 12px;
    }

    .catalog-card__body { min-height: 0; padding: 10px 9px 12px; }

    .catalog-card__favorite { opacity: 1; right: 8px; top: 8px; }

    .catalog-card__gallery-arrow { height: 32px; width: 32px; }
    .catalog-card__gallery-arrow--prev { left: 7px; }
    .catalog-card__gallery-arrow--next { right: 7px; }
}

@media (max-width: 640px) {
    .catalog-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (hover: none), (pointer: coarse) {
    .catalog-card__image-frame,
    .catalog-card__image-wrap {
        background: #ffffff;
        border: 0;
        box-shadow: none;
        outline: 0;
    }

    .catalog-card__image-track {
        transition-duration: 0.22s;
        transition-timing-function: cubic-bezier(.2, .8, .2, 1);
    }

    .catalog-card__gallery-nav {
        display: none !important;
    }

    .catalog-card__image-progress {
        bottom: 7px;
        display: flex;
        gap: 3px;
        left: 8px;
        pointer-events: none;
        position: absolute;
        right: 8px;
        z-index: 2;
    }

    .catalog-card__image-progress span {
        background: rgba(23, 32, 28, .2);
        flex: 1 1 0;
        height: 2px;
        min-width: 0;
        transition: background-color .24s ease, transform .24s ease;
    }

    .catalog-card__image-progress span.is-active {
        background: var(--mg-ink);
        transform: scaleY(1.35);
    }
}

@media (max-width: 820px), (any-pointer: coarse) {
    .catalog-card__gallery-nav,
    .catalog-card__gallery-arrow {
        display: none !important;
        opacity: 0 !important;
        pointer-events: none !important;
        visibility: hidden !important;
    }
}

@media (prefers-reduced-motion: reduce) {
    .catalog-card__image,
    .catalog-card__image-track,
    .catalog-card__body,
    .catalog-card__favorite {
        transition: none;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Catalog/Catalog.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,eAAe;IACf,eAAe;IACf,WAAW;AACf;;AAEA;IACI,8CAA8C;IAC9C,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,SAAS;IACT,qCAAqC;AACzC;;AAEA;IACI,4BAA4B;IAC5B,iCAAiC;IACjC,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,SAAS;IACT,oBAAoB;AACxB;;AAEA,qFAAqF;AACrF;;;IAGI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,gDAAgD;IAChD,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,SAAS;IACT,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,0DAA0D;IAC1D,WAAW;AACf;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,MAAM;IACN,sBAAsB;IACtB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,8CAA8C;IAC9C,aAAa;IACb,SAAS;IACT,8BAA8B;IAC9B,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,SAAS;AACb;;AAEA;;IAEI,cAAc;IACd,eAAe;IACf,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,eAAe;IACf,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,MAAM;IACN,gDAAgD;IAChD,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,6BAA6B;IAC7B,UAAU;AACd;;AAEA;IACI,uBAAuB;IACvB,SAAS;IACT,oBAAoB;IACpB,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,UAAU;IACV,kBAAkB;IAClB,mBAAmB;IACnB,wCAAwC;AAC5C;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;;IAEI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,cAAc;IACd,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;IACpB,yBAAiB;YAAjB,iBAAiB;IACjB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,yDAAyD;IACzD,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,QAAQ;IACR,UAAU;IACV,oBAAoB;IACpB,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;;IAEI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,WAAW;IACX,eAAe;IACf,aAAa;IACb,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,oDAAoD;AACxD;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,+BAA+B;IAC/B,oBAAoB;AACxB;;AAEA,qCAAqC,UAAU,EAAE;AACjD,qCAAqC,WAAW,EAAE;;AAElD;IACI,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,UAAU;IACV,sBAAsB;IACtB,UAAU;IACV,kBAAkB;IAClB,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,QAAQ;IACR,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI;QACI,kBAAkB;QAClB,0BAA0B;IAC9B;;IAEA;QACI,QAAQ;QACR,UAAU;QACV,kBAAkB;QAClB,wDAAwD;QACxD,oBAAoB;IACxB;;IAEA;QACI,UAAU;QACV,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;QAC1B,0DAA0D;IAC9D;;IAEA;QACI,0BAA0B;QAC1B,wDAAwD;IAC5D;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,2BAA2B;IAC3B,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kCAAkC;IAClC,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,aAAa;IACb,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,qBAAqB;IACrB,yBAAyB;IACzB,uDAAuD;IACvD,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI;QACI,gDAAgD;IACpD;AACJ;;AAEA;IACI;QACI,gDAAgD;IACpD;AACJ;;AAEA;IACI;QACI,gDAAgD;IACpD;AACJ;;AAEA;IACI,iBAAiB,eAAe,EAAE;;IAElC;QACI,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA,yBAAyB,iBAAiB,EAAE;;IAE5C;QACI,aAAa;QACb,mBAAmB;QACnB,gBAAgB;QAChB,qBAAqB;IACzB;;IAEA,yCAAyC,aAAa,EAAE;;IAExD,4BAA4B,eAAe,EAAE;;AAEjD;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,MAAM;QACN,gDAAgD;IACpD;;IAEA;;QAEI,WAAW;IACf;;IAEA,yBAAyB,WAAW,EAAE;;IAEtC;QACI,aAAa;QACb,0CAA0C;QAC1C,8BAA8B;QAC9B,WAAW;IACf;;IAEA;QACI,iBAAiB;QACjB,gBAAgB;QAChB,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;;IAEA;;;QAGI,eAAe;IACnB;;IAEA,sBAAsB,aAAa,EAAE,sBAAsB,EAAE;;IAE7D,0BAA0B,UAAU,EAAE,UAAU,EAAE,QAAQ,EAAE;;IAE5D,+BAA+B,YAAY,EAAE,WAAW,EAAE;IAC1D,qCAAqC,SAAS,EAAE;IAChD,qCAAqC,UAAU,EAAE;AACrD;;AAEA;IACI;QACI,gDAAgD;IACpD;AACJ;;AAEA;IACI;;QAEI,mBAAmB;QACnB,SAAS;QACT,gBAAgB;QAChB,UAAU;IACd;;IAEA;QACI,0BAA0B;QAC1B,uDAAuD;IAC3D;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,WAAW;QACX,aAAa;QACb,QAAQ;QACR,SAAS;QACT,oBAAoB;QACpB,kBAAkB;QAClB,UAAU;QACV,UAAU;IACd;;IAEA;QACI,gCAAgC;QAChC,WAAW;QACX,WAAW;QACX,YAAY;QACZ,2DAA2D;IAC/D;;IAEA;QACI,yBAAyB;QACzB,uBAAuB;IAC3B;AACJ;;AAEA;IACI;;QAEI,wBAAwB;QACxB,qBAAqB;QACrB,+BAA+B;QAC/B,6BAA6B;IACjC;AACJ;;AAEA;IACI;;;;QAII,gBAAgB;IACpB;AACJ","sourcesContent":[".catalog-page {\n    background: #ffffff;\n    color: var(--mg-ink);\n    overflow-x: clip;\n    padding: 0 0 72px;\n}\n\n.catalog-shell {\n    box-sizing: border-box;\n    margin: 0 auto;\n    max-width: none;\n    padding: 0 18px;\n    width: 100%;\n}\n\n.catalog-hero {\n    border-bottom: 1px solid rgba(17, 17, 17, 0.1);\n    padding: 20px 0 28px;\n}\n\n.catalog-hero__content {\n    align-items: baseline;\n    display: grid;\n    gap: 20px;\n    grid-template-columns: minmax(0, 1fr);\n}\n\n.catalog-hero__title {\n    font-family: var(--mg-serif);\n    font-size: clamp(28px, 3vw, 44px);\n    font-weight: 500;\n    letter-spacing: 0;\n    line-height: 1.15;\n    margin: 0;\n    text-transform: none;\n}\n\n/* Catalog pages begin with controls; category context already lives in the header. */\n.catalog-shell > .breadcrumbs__navigation_chain,\n.catalog-shell > .catalog-hero,\n.catalog-shell > .catalog-visual-nav {\n    display: none;\n}\n\n.catalog-visual-nav {\n    display: grid;\n    gap: 1px;\n    grid-template-columns: repeat(6, minmax(0, 1fr));\n    overflow: hidden;\n    padding: 20px 0 26px;\n}\n\n.catalog-visual-nav__item {\n    color: inherit;\n    display: grid;\n    gap: 10px;\n    min-width: 0;\n    text-decoration: none;\n}\n\n.catalog-visual-nav__image-wrap {\n    aspect-ratio: 1 / 1;\n    background: #f2f2f2;\n    display: block;\n    overflow: hidden;\n}\n\n.catalog-visual-nav__image {\n    display: block;\n    height: 100%;\n    object-fit: contain;\n    transition: transform 0.45s cubic-bezier(.22, .61, .36, 1);\n    width: 100%;\n}\n\n.catalog-visual-nav__item:hover .catalog-visual-nav__image {\n    transform: scale(1.025);\n}\n\n.catalog-visual-nav__title {\n    font-size: 12px;\n    line-height: 1.3;\n    padding: 0 8px;\n}\n\n.catalog-hero__description {\n    color: #6b6b6b;\n    font-size: 14px;\n    line-height: 1.65;\n    margin: 18px 0 0;\n    max-width: 560px;\n}\n\n.catalog-hero__meta {\n    color: #6b6b6b;\n    display: flex;\n    flex-direction: column;\n    font-size: 11px;\n    gap: 0;\n    letter-spacing: 0.08em;\n    text-align: right;\n    text-transform: uppercase;\n}\n\n.catalog-toolbar {\n    align-items: center;\n    border-bottom: 1px solid rgba(17, 17, 17, 0.1);\n    display: flex;\n    gap: 16px;\n    justify-content: space-between;\n    min-height: 58px;\n    padding: 8px 0;\n}\n\n.catalog-toolbar__left {\n    align-items: center;\n    display: flex;\n    gap: 14px;\n}\n\n.catalog-toolbar__count,\n.catalog-toolbar__note {\n    color: #6b6b6b;\n    font-size: 12px;\n    letter-spacing: 0.14em;\n    text-transform: uppercase;\n}\n\n.catalog-toolbar__count {\n    display: inline;\n    margin-left: auto;\n    text-align: right;\n}\n\n.catalog-sort {\n    align-items: center;\n    display: inline-flex;\n    gap: 10px;\n}\n\n.catalog-sort__label {\n    color: #6b6b6b;\n    font-size: 12px;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n}\n\n.catalog-sort__select {\n    background: #ffffff;\n    border: 0;\n    border-radius: 0;\n    color: #111111;\n    font-size: 13px;\n    min-height: 40px;\n    min-width: 180px;\n    padding: 0 12px;\n}\n\n.catalog-grid {\n    display: grid;\n    gap: 0;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n\n.catalog-card {\n    min-width: 0;\n    overflow: hidden;\n    position: relative;\n}\n\n.catalog-card__favorite {\n    opacity: 0;\n    position: absolute;\n    right: 14px;\n    top: 14px;\n    transition: opacity 0.2s ease;\n    z-index: 2;\n}\n\n.catalog-card__favorite button {\n    background: transparent;\n    border: 0;\n    border-radius: 999px;\n    display: inline-flex;\n}\n\n.catalog-card__link {\n    color: inherit;\n    display: block;\n    text-decoration: none;\n}\n\n.catalog-card__image-frame {\n    background: #ffffff;\n    border: 0;\n    border-radius: 0;\n    overflow: hidden;\n    line-height: 0;\n    padding: 0;\n    position: relative;\n    touch-action: pan-y;\n    -webkit-tap-highlight-color: transparent;\n}\n\n.catalog-card__image-link {\n    color: inherit;\n    display: block;\n}\n\n.catalog-card:hover .catalog-card__favorite,\n.catalog-card:focus-within .catalog-card__favorite {\n    opacity: 1;\n}\n\n.catalog-card__image-wrap {\n    aspect-ratio: 1 / 1;\n    background: #ffffff;\n    overflow: hidden;\n    position: relative;\n}\n\n.catalog-card__image {\n    backface-visibility: hidden;\n    display: block;\n    flex: 0 0 100%;\n    height: 100%;\n    object-fit: contain;\n    pointer-events: none;\n    user-select: none;\n    -webkit-user-drag: none;\n    width: 100%;\n}\n\n.catalog-card__image-track {\n    display: flex;\n    height: 100%;\n    transition: transform 0.3s cubic-bezier(.22, .61, .36, 1);\n    width: 100%;\n    will-change: transform;\n}\n\n.catalog-card__image-progress {\n    display: none;\n}\n\n.catalog-card__image.is-muted {\n    opacity: 0.48;\n}\n\n.catalog-card__gallery-nav {\n    inset: 0;\n    opacity: 0;\n    pointer-events: none;\n    position: absolute;\n    transition: opacity 0.18s ease;\n}\n\n.catalog-card:hover .catalog-card__gallery-nav,\n.catalog-card:focus-within .catalog-card__gallery-nav {\n    opacity: 1;\n}\n\n.catalog-card.is-returning .catalog-card__gallery-nav {\n    opacity: 0;\n}\n\n.catalog-card__gallery-arrow {\n    align-items: center;\n    background: transparent;\n    border: 0;\n    color: #111;\n    cursor: pointer;\n    display: flex;\n    font-family: var(--mg-sans);\n    font-size: 27px;\n    font-weight: 500;\n    height: 38px;\n    justify-content: center;\n    line-height: 1;\n    padding: 0 0 3px;\n    pointer-events: auto;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 38px;\n    transition: opacity 0.15s ease, transform 0.15s ease;\n}\n\n.catalog-card__gallery-arrow:active {\n    transform: translateY(-50%) scale(0.9);\n}\n\n.catalog-card__gallery-arrow:focus-visible {\n    outline: 1px solid currentColor;\n    outline-offset: -7px;\n}\n\n.catalog-card__gallery-arrow--prev { left: 12px; }\n.catalog-card__gallery-arrow--next { right: 12px; }\n\n.catalog-card__badge {\n    background: transparent;\n    color: #111111;\n    font-size: 11px;\n    left: 14px;\n    letter-spacing: 0.14em;\n    padding: 0;\n    position: absolute;\n    text-transform: uppercase;\n    top: 14px;\n}\n\n.catalog-card__body {\n    display: grid;\n    align-content: start;\n    gap: 1px;\n    min-height: 0;\n    padding: 11px 12px 14px;\n    text-align: left;\n}\n\n@media (hover: hover) and (pointer: fine) {\n    .catalog-card__image-track {\n        position: relative;\n        transform: none !important;\n    }\n\n    .catalog-card__image {\n        inset: 0;\n        opacity: 0;\n        position: absolute;\n        transition: opacity 0.32s cubic-bezier(.22, .61, .36, 1);\n        will-change: opacity;\n    }\n\n    .catalog-card__image.is-active {\n        opacity: 1;\n        z-index: 1;\n    }\n\n    .catalog-card__image.is-muted {\n        opacity: 0;\n    }\n\n    .catalog-card__image.is-active.is-muted {\n        opacity: 0.48;\n    }\n\n    .catalog-card.is-hover-preview .catalog-card__image {\n        transition-duration: 0.52s;\n        transition-timing-function: cubic-bezier(.22, .61, .36, 1);\n    }\n\n    .catalog-card.is-returning .catalog-card__image {\n        transition-duration: 0.72s;\n        transition-timing-function: cubic-bezier(.33, 1, .68, 1);\n    }\n}\n\n.catalog-card__brand {\n    font-size: 12px;\n    font-weight: 700;\n    letter-spacing: -0.01em;\n    line-height: 1.35;\n    text-transform: uppercase;\n    white-space: nowrap;\n}\n\n.catalog-card__title {\n    color: #292929;\n    font-family: var(--mg-sans);\n    display: block;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 1.45;\n    min-height: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.catalog-card__details {\n    color: #6b6b6b;\n    font-size: 12px;\n    line-height: 1.5;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n}\n\n.catalog-card__price {\n    color: #111111;\n    font-size: 12px;\n    font-variant-numeric: tabular-nums;\n    font-weight: 700;\n    padding-top: 0;\n}\n\n.catalog-card__price-row {\n    align-items: center;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px 12px;\n    justify-content: flex-start;\n    margin-top: 9px;\n}\n\n.catalog-card__price--old {\n    color: #8e8a84;\n    font-weight: 500;\n    text-decoration: line-through;\n}\n\n.catalog-load-more {\n    margin: 40px auto 0;\n    max-width: 520px;\n    text-align: center;\n}\n\n.catalog-load-more__count {\n    color: #171717;\n    font-size: 13px;\n    letter-spacing: 0.04em;\n    margin-bottom: 24px;\n}\n\n.catalog-load-more__button {\n    align-items: center;\n    border: 1px solid #171717;\n    color: #171717;\n    cursor: pointer;\n    display: flex;\n    font-size: 14px;\n    font-weight: 500;\n    justify-content: center;\n    letter-spacing: 0.08em;\n    min-height: 64px;\n    padding: 0 24px;\n    text-decoration: none;\n    text-transform: uppercase;\n    transition: background-color 0.2s ease, color 0.2s ease;\n    width: 100%;\n}\n\n.catalog-load-more__button:hover:not(:disabled) {\n    background: #171717;\n    color: #ffffff;\n}\n\n.catalog-load-more__button:disabled {\n    cursor: wait;\n    opacity: 0.55;\n}\n\n@media (max-width: 1100px) {\n    .catalog-grid {\n        grid-template-columns: repeat(3, minmax(0, 1fr));\n    }\n}\n\n@media (min-width: 1600px) {\n    .catalog-grid {\n        grid-template-columns: repeat(5, minmax(0, 1fr));\n    }\n}\n\n@media (min-width: 2100px) {\n    .catalog-grid {\n        grid-template-columns: repeat(6, minmax(0, 1fr));\n    }\n}\n\n@media (max-width: 820px) {\n    .catalog-shell { padding: 0 12px; }\n\n    .catalog-toolbar {\n        align-items: center;\n        flex-direction: row;\n    }\n\n    .catalog-toolbar__left { flex-wrap: nowrap; }\n\n    .catalog-visual-nav {\n        display: flex;\n        margin-right: -12px;\n        overflow-x: auto;\n        scrollbar-width: none;\n    }\n\n    .catalog-visual-nav::-webkit-scrollbar { display: none; }\n\n    .catalog-visual-nav__item { flex: 0 0 132px; }\n\n}\n\n@media (max-width: 540px) {\n    .catalog-page {\n        padding-top: 0;\n    }\n\n    .catalog-hero__title {\n        font-size: 30px;\n    }\n\n    .catalog-grid {\n        gap: 0;\n        grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n\n    .catalog-toolbar,\n    .catalog-toolbar__left {\n        width: 100%;\n    }\n\n    .catalog-toolbar__left { width: auto; }\n\n    .catalog-sort {\n        display: grid;\n        grid-template-columns: auto minmax(0, 1fr);\n        justify-content: space-between;\n        width: 100%;\n    }\n\n    .catalog-sort__select {\n        justify-self: end;\n        max-width: 190px;\n        min-width: 0;\n        width: 100%;\n    }\n\n    .catalog-card__image-frame {\n        padding: 0;\n    }\n\n    .catalog-card__title {\n        font-size: 12px;\n    }\n\n    .catalog-card__brand,\n    .catalog-card__details,\n    .catalog-card__price {\n        font-size: 12px;\n    }\n\n    .catalog-card__body { min-height: 0; padding: 10px 9px 12px; }\n\n    .catalog-card__favorite { opacity: 1; right: 8px; top: 8px; }\n\n    .catalog-card__gallery-arrow { height: 32px; width: 32px; }\n    .catalog-card__gallery-arrow--prev { left: 7px; }\n    .catalog-card__gallery-arrow--next { right: 7px; }\n}\n\n@media (max-width: 640px) {\n    .catalog-grid {\n        grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n}\n\n@media (hover: none), (pointer: coarse) {\n    .catalog-card__image-frame,\n    .catalog-card__image-wrap {\n        background: #ffffff;\n        border: 0;\n        box-shadow: none;\n        outline: 0;\n    }\n\n    .catalog-card__image-track {\n        transition-duration: 0.22s;\n        transition-timing-function: cubic-bezier(.2, .8, .2, 1);\n    }\n\n    .catalog-card__gallery-nav {\n        display: none !important;\n    }\n\n    .catalog-card__image-progress {\n        bottom: 7px;\n        display: flex;\n        gap: 3px;\n        left: 8px;\n        pointer-events: none;\n        position: absolute;\n        right: 8px;\n        z-index: 2;\n    }\n\n    .catalog-card__image-progress span {\n        background: rgba(23, 32, 28, .2);\n        flex: 1 1 0;\n        height: 2px;\n        min-width: 0;\n        transition: background-color .24s ease, transform .24s ease;\n    }\n\n    .catalog-card__image-progress span.is-active {\n        background: var(--mg-ink);\n        transform: scaleY(1.35);\n    }\n}\n\n@media (max-width: 820px), (any-pointer: coarse) {\n    .catalog-card__gallery-nav,\n    .catalog-card__gallery-arrow {\n        display: none !important;\n        opacity: 0 !important;\n        pointer-events: none !important;\n        visibility: hidden !important;\n    }\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .catalog-card__image,\n    .catalog-card__image-track,\n    .catalog-card__body,\n    .catalog-card__favorite {\n        transition: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
